/**
 * Text used in the general info page.
 */
export const GeneralInfoHelperMessages = {
    /**
     * Question: (3a)
     */
    demonstrationLicense:
        "If this application is for a Demonstration License or a Special Temporary Authorization (STA), enter the code and attach the required exhibit as described in the instructions Otherwise enter 'N' (Not Applicable).",

    /**
     * Question: (4)
     */
    applicationFileNumber:
        'If this application is for an Amendment or Withdrawal, enter the file number of the pending application currently on file with the FCC.',

    /**
     * Question: (5)
     */
    callSignOfExistingFccLicense:
        'If this application is for a Modification, Renewal Only, Renewal/Modification, Cancellation of License, Duplicate License, or Administrative Update, enter the call sign of the existing FCC license. If this is a request for Registered Location/Link, enter the FCC call sign assigned to the geographic license.',

    /**
     * Question: (6a)
     */
    requestedExpirationDate:
        'If this application is for a New, Amendment, Renewal Only, or Renewal/Modification, enter the requested authorization expiration date (this item is optional).',

    /**
     * Question: (6b)
     */
    licenseType:
        'If this application is for a Renewal Only or Renewal/Modification and the license is a geographic area license, is the license used to provide service to customers (C), or is the license used for private business (internal) purposes or to meet the licensee’s public interest/public safety communications needs (P)?',

    /**
     * Question: (7)
     */
    applicationMajor:
        'Is this application "major" as defined in 1.929 of the Commission\'s Rules when read in conjunction with the applicable radio service rules found in Parts 22 and 90 of the Commission\'s Rules? (NOTE: This question only applies to certain site-specific applications. See the instructions for applicability and full text of 1.929).',

    /**
     * Question: (8)
     */
    attachments:
        'Are attachments (other than associated schedules) being filed with this application?',
};
